module.exports = __webpack_public_path__ + "img/upper.464bdb9e.png";